import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
    Card,
    CardContent,
    Typography, Skeleton, Alert
} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";
import SearchIcon from '@mui/icons-material/Search';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useState} from "react";
import axios from "axios";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import {WordPressToolsTrackingLTL} from "./WordPressToolsTrackingLTL";
import {WordPressToolsTrackingParcel} from "./WordPressToolsTrackingParcel";

export const WordPressToolsTracking = () => {

    const theme = useTheme();

    const {lng} = useParams();

    const uiText = getI18nContent(lng, 'LTLTools');

    const [searchType, setSearchType] = useState('bol');
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const retrieveLTLTrackingForConsignee = async () => {

        if (!searchValue.trim()) return;

        try {
            setLoading(true);
            setError(false);
            setTrackingData(null);

            const paramKeyMap = {
                bol: 'bolNumber',
                pro: 'proNumber',
                pickup: 'pickupConfirmationNumber',
                tracking: 'trackingNumber'
            };

            const activeParamKey = paramKeyMap[searchType];

            const requestURL = searchType === 'tracking' ? `${NODE_ROUTE_URI}/trackingEventHistory/getTrackingEventHistoryListByTrackingNumber` :
                `${PARTNER_URI}/shippingLTLTracking/retrieveLTLTrackingForConsignee`;
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    [activeParamKey]: searchValue.trim()
                }
            });

            setTrackingData(result.data);

            setError(false);
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleSearchValue = (event) => {
        const {value} = event.target;
        setSearchValue(value);
    }

    const handleSearch = async () => {
        await retrieveLTLTrackingForConsignee()
    }

    console.log('[WordPressToolsTracking] tracking data', trackingData);

    return (
        <Grid container spacing={1}>
            <Grid size={{md: 12, xs: 12}}>
                <FormControl component="fieldset">
                    <RadioGroup
                        row
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        sx={{alignItems: 'center'}}
                    >
                        <FormControlLabel
                            value="bol"
                            control={<Radio size="small"/>}
                            label={uiText.search.types.bol}
                            slotProps={{typography: {variant: 'caption', fontWeight: 600}}}
                        />
                        <FormControlLabel
                            value="pro"
                            control={<Radio size="small"/>}
                            label={uiText.search.types.pro}
                            slotProps={{typography: {variant: 'caption', fontWeight: 600}}}
                        />
                        <FormControlLabel
                            value="pickup"
                            control={<Radio size="small"/>}
                            label={uiText.search.types.pickup}
                            slotProps={{typography: {variant: 'caption', fontWeight: 600}}}
                        />
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{mx: 2, height: '16px', alignSelf: 'center', borderColor: theme.palette.neutral[600]}}
                        />
                        <FormControlLabel
                            value="tracking"
                            control={<Radio size="small"/>}
                            label={uiText.search.types.tracking}
                            slotProps={{typography: {variant: 'caption', fontWeight: 600}}}
                        />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid size={{md: 12, xs: 12}}>
                <FormControl fullWidth>
                    <TextField
                        value={searchValue}
                        fullWidth
                        variant='outlined'
                        required
                        label={`${uiText.search.label}: ${uiText.search.types[searchType]}`}
                        placeholder={uiText.search.placeholder}
                        onInput={handleSearchValue}
                        size='small'
                        slotProps={{
                            input: {
                                sx: {
                                    borderRadius: theme.shape.lg,
                                    backgroundColor: theme.palette.background.default,
                                    transition: '0.3s',
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleSearch}
                                            startIcon={<SearchIcon fontSize="small"/>}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: theme.shape.lg,
                                            }}
                                        >
                                            {uiText.search.button.track}
                                        </Button>
                                    </InputAdornment>
                                ),
                            },
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            {loading && (
                <Grid size={{xs: 12}}>
                    <Card sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        <CardContent>
                            <Skeleton variant="text" width="40%" height={30}/>
                            <Divider sx={{my: 2}}/>
                            <Skeleton variant="rectangular" height={60} sx={{mb: 1, borderRadius: 1}}/>
                            <Skeleton variant="rectangular" height={60} sx={{borderRadius: 1}}/>
                        </CardContent>
                    </Card>
                </Grid>
            )}
            {error && (
                <Grid size={{xs: 12}}>
                    <Alert severity="error" icon={<ErrorOutlineIcon/>} sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        {uiText.search.error}
                    </Alert>
                </Grid>
            )}
            {(!loading && !error && trackingData?.trackingResponse?.activity?.length === 0 && trackingData?.eventList?.length === 0) && (
                <Grid size={{xs: 12}}>
                    <Box sx={{textAlign: 'center', py: 5}}>
                        <Typography color="text.secondary" variant="body2">
                            {uiText.search.noData}
                        </Typography>
                    </Box>
                </Grid>
            )}
            {(searchType !== 'tracking' && !loading && !error && trackingData?.trackingResponse?.activity?.length > 0) && (
                <Grid size={{xs: 12}}>
                    <WordPressToolsTrackingLTL trackingData={trackingData}/>
                </Grid>
            )}
            {(searchType === 'tracking' && !loading && !error && trackingData?.eventList?.length > 0) && (
                <Grid size={{xs: 12}}>
                    <WordPressToolsTrackingParcel trackingData={trackingData}/>
                </Grid>
            )}
        </Grid>
    )
}